var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-navbar"},[_c('div',{staticClass:"custom-logo d-flex align-items-center"},[_c('MyLogo')],1),_c('button',{staticClass:"custom-back-to-home",on:{"click":_vm.backToHome}},[_vm._v(" Back to home page ")])])}
var staticRenderFns = []

export { render, staticRenderFns }